import React, { useState, useEffect } from "react";
import { Typography, Drawer, Modal } from "antd";
import {
  IoGridOutline,
  IoHomeOutline,
  IoHome,
  IoReceiptOutline,
  IoPersonOutline,
  IoSparklesOutline,
  IoChevronForwardOutline,
} from "react-icons/io5";
import SideMenu from "./SideMenu";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { siteInfo } from "../utils/SiteInfo";

const { Text } = Typography;


const masterLinks = [
  { label: "Ideas", path: "/ideas" },
  { label: "Office Complains", path: "/office-complains" },
  { label: "Master Order Report", path: "/master-order-report" },
  { label: "Master Payment Report", path: "/master-payment-report" },
  { label: "Master Due Report", path: "/master-due-report" },
  { label: "Master Activity Log", path: "/master-activity-log" },
  { label: "Master Balance Report", path: "/master-balance-report" },
];

const ICON_COLOR = "#6b7280";
const ACTIVE_COLOR = "#D1412A";

export default function Bottombar() {
  const [drawer, setDrawer] = useState(false);
  const [masterOpen, setMasterOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;

  const profile = useSelector((state) => state.auth.profile);
  const isMaster = siteInfo.masterAccess?.includes(profile?.phone);

  useEffect(() => {
    setDrawer(false);
    setMasterOpen(false);
  }, [location]);

  const isActive = (p) => path === p;

  let activated = siteInfo.isActivated();

  if (!activated) {
    return null
  }

  const tabBase = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    flex: 1,
    cursor: "pointer",
    padding: "6px 0 2px",
    gap: 3,
  };

  const label = (text, active) => (
    <Text
      style={{
        fontSize: 10,
        fontWeight: active ? 600 : 400,
        color: active ? ACTIVE_COLOR : ICON_COLOR,
        letterSpacing: 0.2,
      }}
    >
      {text}
    </Text>
  );

  return (
    <>
      {/* ── Bottom Bar ─────────────────────────────── */}
      <div
        className="bottomBar"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0 4px",
          userSelect: 'none'
        }}
      >
        {/* LEFT — Menu */}
        <div style={tabBase} onClick={() => setDrawer(true)}>
          <IoGridOutline size={20} color={ICON_COLOR} />
          {label("Menu", false)}
        </div>

        {/* Orders */}
        <Link
          to="/orders"
          style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <div style={tabBase}>
            <IoReceiptOutline size={20} color={isActive("/orders") ? ACTIVE_COLOR : ICON_COLOR} />
            {label("Orders", isActive("/orders"))}
          </div>
        </Link>

        {/* CENTER — Home (prominent pill) */}
        <Link
          to="/"
          style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: 2,
              cursor: "pointer",
            }}
          >
            <div
              style={{
                width: 46,
                height: 46,
                borderRadius: "50%",
                background: ACTIVE_COLOR,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s",
                marginBottom: 2,
              }}
            >
              <IoHome size={22} color={"#fff"} />
            </div>
            {/* {label("Home", isActive("/"))} */}
          </div>
        </Link >

        {/* Account */}
        < Link
          to="/profile"
          style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }
          }
        >
          <div style={tabBase}>
            <IoPersonOutline size={20} color={isActive("/profile") ? ACTIVE_COLOR : ICON_COLOR} />
            {label("Account", isActive("/profile"))}
          </div>
        </Link >

        {/* RIGHT — Master (gated) */}
        {
          isMaster ? (
            <div style={tabBase} onClick={() => setMasterOpen(true)}>
              <IoSparklesOutline size={20} color="#f59e0b" />
              {label("Master", false)}
            </div>
          ) : (
            /* placeholder so Home stays centered when no Master tab */
            <div style={{ flex: 1 }} />
          )
        }
      </div >

      {/* ── Side-menu drawer ───────────────────────── */}
      < Drawer
        placement="left"
        headerStyle={{ padding: 0 }}
        width={"75%"}
        bodyStyle={{ padding: 0 }}
        closeIcon={false}
        onClose={() => setDrawer(false)}
        open={drawer}
      >
        <SideMenu setDrawer={setDrawer} />
      </Drawer >

      {/* ── Master links modal ─────────────────────── */}
      < Modal
        title={
          < span style={{ fontWeight: 700, fontSize: 15, display: "flex", alignItems: "center", gap: 6 }}>
            <IoSparklesOutline size={16} color="#f59e0b" /> Master Panel
          </span >
        }
        open={masterOpen}
        onCancel={() => setMasterOpen(false)}
        footer={null}
        centered
        bodyStyle={{ padding: "12px 16px 16px" }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {masterLinks.map(({ label: lbl, path: p }) => (
            <div
              key={p}
              onClick={() => { navigate(p); setMasterOpen(false); }}
              style={{
                padding: "13px 16px",
                borderRadius: 10,
                background: "#f7f8fa",
                cursor: "pointer",
                fontWeight: 500,
                fontSize: 14,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                transition: "background 0.15s",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#eceef2")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "#f7f8fa")}
            >
              <span>{lbl}</span>
              <IoChevronForwardOutline size={15} color="#aaa" />
            </div>
          ))}
        </div>
      </Modal >
    </>
  );
}
